import { render } from "./AvailableServicesView.vue?vue&type=template&id=7c31d7af"
import script from "./AvailableServicesView.vue?vue&type=script&lang=js"
export * from "./AvailableServicesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__